import React from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { ReactComponent as Calendar } from 'src/Images/icons/common/calendar.svg';
import { ReactComponent as Search } from 'src/Images/icons/common/search.svg';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';
import getColorCode from 'src/utils/GetThemeColor';

export default function TransporterListMobileFilterDrawer({
  formData,
  handleSearchInputChange,
  handleResetFilter,
  handleApplyFilter,
  closeFilter,
  transporterDataOption,
  transporterValue,
  setTransporterSearchTerm,
}) {
  const themeColor = useSelector(
    (state) => state.AuthReducer?.userData?.tenant?.theme,
  );

  return (
    <div className="div-flex-column">
      <div
        className="filter-list-item div-flex-row div-space-between div-align-center border-bottom"
        data-testid="filter-drawer"
      >
        <span className="text-sm text-semi-bold">Filter</span>
        <button
          className="icon-btn-none"
          onClick={closeFilter}
          aria-label="Close filter"
        >
          <Close className="icon-size-sm" color={getColorCode(themeColor)} />
        </button>
      </div>
      <div className="div-flex-column div-space-between rg-20">
        <div className="filter-list-item-container-scroll div-flex-column">
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Status</span>
            <select
              name="status"
              value={formData.status || ''}
              onChange={handleSearchInputChange}
              className="form-input-section"
            >
              <option value="">Select Status</option>
              <option value="1">Idle</option>
              <option value="2">Scheduled</option>
              <option value="3">In Progress</option>
            </select>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Start Date</span>
            <div className="input-wrapper">
              <input
                type="date"
                name="startDate"
                value={formData.startDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">End Date</span>
            <div className="input-wrapper">
              <input
                type="date"
                name="endDate"
                value={formData.endDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Transporter Id</span>
            <div className="input-wrapper">
              <CustomMultiSelect
                name="transporterId"
                isMulti={false}
                className="multi-select-input-section"
                onChange={(selectedOption) => {
                  handleSearchInputChange({
                    target: {
                      name: 'transporterId',
                      value: selectedOption?.value || '',
                    },
                  });
                  setTransporterSearchTerm('');
                }}
                onInputChange={(inputValue, { action }) => {
                  if (action === 'input-change') {
                    setTransporterSearchTerm(inputValue);
                  }
                }}
                options={transporterDataOption}
                classNamePrefix="react-select"
                placeholder="Search Transporter Id"
                value={transporterValue}
                onBlur={() => setTransporterSearchTerm('')}
              />
              {!formData.transporterId && (
                <span className="form-input-section-icon">
                  <Search className="icon-size-sm" color="#9F9F9F" />
                </span>
              )}
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Capacity Min</span>
            <input
              type="number"
              name="capacityMin"
              value={formData.capacityMin || ''}
              onChange={handleSearchInputChange}
              className="form-input-section"
            />
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Capacity Max</span>
            <input
              type="number"
              name="capacityMax"
              value={formData.capacityMax || ''}
              onChange={handleSearchInputChange}
              className="form-input-section"
            />
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Insurance Start Date</span>
            <div className="input-wrapper">
              <input
                type="date"
                name="insuranceStartDate"
                value={formData.insuranceStartDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Insurance End Date</span>
            <div className="input-wrapper">
              <input
                type="date"
                name="insuranceEndDate"
                value={formData.insuranceEndDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">
              Fitness / Inspection Start Date
            </span>
            <div className="input-wrapper">
              <input
                type="date"
                name="fitnessStartDate"
                value={formData.fitnessStartDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">
              Fitness / Inspection End Date
            </span>
            <div className="input-wrapper">
              <input
                type="date"
                name="fitnessEndDate"
                value={formData.fitnessEndDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="div-flex-row div-space-between div-align-center border-top filter-list-item footer-content-for-component">
          <button
            className={`common-btn-outlined border-${themeColor}`}
            onClick={handleResetFilter}
            data-testid="filter-reset-btn"
          >
            Reset
          </button>
          <button
            className={`common-btn theme-background-${themeColor}`}
            onClick={handleApplyFilter}
            data-testid="filter-apply-btn"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
